import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import ShareButton from '../molecules/ShareButton';
import OutlineButton from '../atoms/OutlineButton';
import { useNavigate } from 'react-router-dom';
import { useLetterStore } from '@/store/letterStore';
import { useAiStore } from '@/store/aiStore';

interface ShareModalProps {
  open: boolean;
  letterId: string;
  fromName: string;
  onClose?: () => void;
}

const ShareModal: React.FC<ShareModalProps> = ({
  open,
  letterId,
  fromName,
  onClose,
}) => {
  const { clearLetterData } = useLetterStore();
  const { clearAiData } = useAiStore();
  const navigate = useNavigate();

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className='c-dialog-overlay' />
        <Dialog.Content
          className='c-dialog-content'
          style={{ maxWidth: '600px' }}
        >
          <Dialog.Close asChild>
            <div className='modal-default-button-wrapper'>
              <button className='modal-default-button'>
                <img src='/img/common/btn-close.png' alt='閉じる' />
              </button>
            </div>
          </Dialog.Close>
          <div className='p-share-modal'>
            <div className='p-share-modal__inner'>
              <h2 className='p-share-modal__title'>メッセージを送る</h2>
              <div className='p-share-modal__buttons'>
                <ShareButton type='url' letterId={letterId} />
                <ShareButton type='line' letterId={letterId} />
                <ShareButton type='x' letterId={letterId} fromName={fromName} />
              </div>
              <div className='p-share-modal__divider'>
                <span>OR</span>
              </div>
              <div className='p-share-modal__buttons'>
                <OutlineButton
                  onClick={() => {
                    clearLetterData();
                    clearAiData();
                    navigate('/question');
                  }}
                >
                  もう一度はじめから作る
                </OutlineButton>
              </div>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ShareModal;
